import { Component, OnInit } from '@angular/core';
import { UserDeviceService } from '../services/user-device.service';
import { UserService } from '../services/user.service';
import { DeviceService } from '../services/device.service';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';

@Component({
  selector: 'app-user-device',
  templateUrl: './user-device.component.html',
  styleUrls: ['./user-device.component.css'],
  providers: [ConfirmationService]
})
export class UserDeviceComponent implements OnInit {

  msgs: Message[] = [];
  userDevice: any;
  userDevices : any [];
  users:SelectItem[];
  devices:SelectItem[];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  statusFilter: SelectItem[];
  blockedDocument: boolean = false;

  constructor(private userDeviceService : UserDeviceService,private userService : UserService,
    private deviceService : DeviceService,private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.init();
    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
    this.statusFilter = [
            {label: 'Todos', value: null },
            {label: 'Habilitado', value: 'H'},
            {label: 'Inhabilitado', value: 'I'}
        ];
    this.users = [];
    this.userService.findAll().then(data => {
      let response: any = data;
      response.users.forEach(item => {
        this.users.push({label: item.nickName, value: item.idUser});
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

    this.devices = [];
    this.deviceService.findAll().then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devices.push({label: item.name, value: item.idDevice});
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
  }

  init(){
    this.userDevices = [];
    this.userDeviceService.findAll().then(data => {
      let response: any = data;
      response.userDevices.forEach(item => {
        this.userDevices.push(item);
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
    this.userDevice = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(userDevice:any){
    this.userDevice=userDevice;
    this.displayEdit = true;
  }

  hide(){
    this.userDevice = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.userDeviceService.create(this.userDevice).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.userDeviceService.edit(this.userDevice).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(idUser: String,idDevice: String){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.userDeviceService.remove(idUser,idDevice).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }

  showMonitoring(device:any){
    let parameters = {idDevice:device.idDevice,idUser:this.userService.userLoged.idUser};
    window.open(window.location.href.replace("userDevice","monitoring?token="+btoa(JSON.stringify(parameters))), "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/app/user-device/user-device.component.ts